import React from 'react';
import { HorizontalGroup, VerticalGroup } from '@libs/uikit/Components';
import { StyledTB } from './StyledTB';
import { Title } from './Title';

export const Integration = ({ selectTab, activeTab }) => {
    const isActive = (name) => activeTab === name;

    return (
        <VerticalGroup style={{ marginRight: '32px' }}>
            <Title>Select integration option</Title>
            <HorizontalGroup itemShift="0">
                <StyledTB onClick={() => selectTab('DFP')} active={isActive('DFP')} size="S">
                    DFP
                </StyledTB>
                <StyledTB onClick={() => selectTab('SAFE FRAME')} active={isActive('SAFE FRAME')} size="L">
                    DFP Safeframe
                </StyledTB>
                <StyledTB onClick={() => selectTab('DIRECT')} active={isActive('DIRECT')} size="M">
                    Direct
                </StyledTB>
            </HorizontalGroup>
        </VerticalGroup>
    );
};
